var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 33,
    viewBox: "0 0 25 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5776 10.3537L23.9762 12.6825C24.0126 12.7167 24.0416 12.7581 24.0614 12.804C24.0813 12.8499 24.0915 12.8994 24.0915 12.9494C24.0915 12.9994 24.0813 13.0488 24.0614 13.0948C24.0416 13.1407 24.0126 13.182 23.9762 13.2163L14.0547 23.0432C13.9791 23.1188 13.9791 23.1188 13.902 23.1188L8.21472 24.9486C7.90636 25.0257 7.67654 24.7974 7.75363 24.4919L9.598 18.8541C9.598 18.7785 9.67509 18.7785 9.67509 18.7014L16.5173 11.9203L18.9784 9.55956L19.2707 9.26865V2.73919H8.89109V6.24465C8.89109 7.46356 7.73763 8.4541 6.58418 8.4541H3.12527V30.169H19.2707V19.8068L21.5776 17.5203V30.169C21.5776 31.2352 20.3471 32.4541 19.2707 32.4541H3.278C1.97181 32.4541 0.818359 31.3108 0.818359 30.2446V6.01628L6.58418 0.454102H19.1951C20.4242 0.454102 21.5776 1.59737 21.5776 2.73919V10.3537Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosts);
export default __webpack_public_path__ + "static/media/posts.e6aa419d2f5069d90ae6144eec9c5f1e.svg";
export { ForwardRef as ReactComponent };